/* ============================================================
   BLESSY UPSELL MODAL — controlador JS
   ============================================================
   Expõe `window.BlessyUpsell` com a API:

     const upsell = window.BlessyUpsell.init({
       // OBRIGATÓRIOS
       mount: '#upsell-mount',          // selector ou HTMLElement
                                        //   onde injetar o markup do modal
       flavors: [                       // catálogo de sabores p/ etapa B
         {
           id: 'abacaxi',
           name: 'Abacaxi c/ hortelã',
           image: '/img/abacaxi.png',
           tag: { type: 'hot', label: 'vendendo rápido' },  // ou null
           soldOut: false
         },
         // ...
       ],

       // OPCIONAIS (têm defaults; sobrescreva o que quiser)
       templateUrl: 'upsell-modal.html', // path do markup HTML
                                         // (se omitir, usa INLINE_TEMPLATE)
       assets: {
         mockup1Pote:   '/img/upgrade-view-1pote.png',
         mockup3Potes:  '/img/upgrade-view-3potes.png',
       },
       prices: {
         single: {
           from: 'De R$213,90', now: 'R$189,90',
           perUnit: '/pote',    saved: '-R$24,00'
         },
         combo: {
           from: 'De R$593,70', now: 'R$109,00',
           perUnit: '/pote',    saved: '-R$266,70',
           total: 'R$327,00'
         }
       },
       copy: {
         headA:        '⚡ ÚLTIMA CHANCE',
         headlineA:    'Adicione + 1 pote ao pedido e GANHE o <mark>3º pote GRÁTIS.</mark>',
         ctaAccept:    'Sim, quero meu pote grátis',
         ctaCaption:   'Você poderá escolher os sabores na próxima tela.',
         ctaDecline:   'continuar com 1 pote',
         headB:        'FINALIZE SUA COMPRA',
         headlineB:    'Escolha o sabor<br>dos outros 2 potes',
         freeBadge:    'pote grátis',
         ctaFinalize:  'FINALIZAR COM 3 POTES — {total}'  // {total} ← prices.combo.total
       },

       // CALLBACKS (substituem o checkout placeholder)
       onAccept: (items) => { ... },   // user finalizou com 3 potes
       onDecline: (items) => { ... },  // user fechou/recusou; só tem 1 pote
       onClose: () => { ... },         // qualquer fechamento (modal A ou B)
     });

   Depois de inicializar:

     upsell.open({ pickedFlavorId: 'abacaxi' });   // abre etapa A
     upsell.close();                                // força fechamento
     upsell.destroy();                              // remove markup + listeners

   ─── Formato dos `items` nos callbacks ────────────────────────
   Array de { id, n } onde `id` bate com `flavors[].id` e `n` é a quantidade.
     onDecline → [{ id: 'abacaxi', n: 1 }]
     onAccept  → [{ id: 'abacaxi', n: 2 }, { id: 'limao', n: 1 }]  (somando duplicados)
   ============================================================ */

(function (root) {
  'use strict';

  // ---- defaults ----
  const DEFAULTS = {
    assets: {
      mockup1Pote:  'assets/upgrade-view-1pote.png',
      mockup3Potes: 'assets/upgrade-view-3potes.png',
    },
    prices: {
      single: { from: 'De R$213,90', now: 'R$189,90', perUnit: '/pote', saved: '-R$24,00' },
      combo:  { from: 'De R$593,70', now: 'R$109,00', perUnit: '/pote', saved: '-R$266,70', total: 'R$327,00' },
    },
    copy: {
      headA:       '⚡ ÚLTIMA CHANCE',
      headlineA:   'Adicione + 1 pote ao pedido e GANHE o <mark>3º pote GRÁTIS.</mark>',
      ctaAccept:   'Sim, quero meu pote grátis',
      ctaCaption:  'Você poderá escolher os sabores na próxima tela.',
      ctaDecline:  'continuar com 1 pote',
      headB:       'FINALIZE SUA COMPRA',
      headlineB:   'Escolha o sabor<br>dos outros 2 potes',
      freeBadge:   'pote grátis',
      ctaFinalize: 'FINALIZAR COM 3 POTES — {total}',
    },
    onAccept:  () => {},
    onDecline: () => {},
    onClose:   () => {},
  };

  // Markup default — usado se templateUrl não for fornecido.
  // (Igual ao upsell-modal.html, só sem comentários, p/ ser autossuficiente.)
  const INLINE_TEMPLATE = `
<div class="upm-overlay" id="upm-overlay" aria-hidden="true">
  <div class="upm upm--a" id="upm-a" role="dialog" aria-modal="true" aria-labelledby="upm-a-headline">
    <div class="upm-head" data-slot="headA"></div>
    <h2 class="upm-headline" id="upm-a-headline" data-slot="headlineA"></h2>
    <div class="upm-compare">
      <div class="upm-card upm-card--current">
        <span class="upm-card-savings" data-slot="single.saved"></span>
        <div class="upm-card-thumb"><img id="upm-a-thumb-current" data-slot="mockup1Pote" alt="1 pote" /></div>
        <div class="upm-price">
          <span class="upm-price-strike" data-slot="single.from"></span>
          <span class="upm-price-now"><span data-slot="single.now"></span><small data-slot="single.perUnit"></small></span>
        </div>
      </div>
      <div class="upm-arrow" aria-hidden="true">
        <svg viewBox="0 0 22 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="1" y1="7" x2="20" y2="7"></line>
          <polyline points="14 1 20 7 14 13"></polyline>
        </svg>
      </div>
      <div class="upm-card upm-card--upgrade">
        <span class="upm-card-savings" data-slot="combo.saved"></span>
        <div class="upm-card-thumb"><img data-slot="mockup3Potes" alt="3 potes" /></div>
        <div class="upm-price">
          <span class="upm-price-strike" data-slot="combo.from"></span>
          <span class="upm-price-now"><span data-slot="combo.now"></span><small data-slot="combo.perUnit"></small></span>
        </div>
      </div>
    </div>
    <div class="upm-actions">
      <button type="button" class="upm-cta upm-cta--accept" id="upm-a-accept" data-slot="ctaAccept">
        <span data-slot-text="ctaAccept"></span>
        <svg viewBox="0 0 18 16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <line x1="2" y1="8" x2="15" y2="8"></line>
          <polyline points="11 3 16 8 11 13"></polyline>
        </svg>
      </button>
      <p class="upm-cta-caption" data-slot="ctaCaption"></p>
      <button type="button" class="upm-cta upm-cta--decline" id="upm-a-decline" data-slot="ctaDecline"></button>
    </div>
  </div>
  <div class="upm upm--b" id="upm-b" role="dialog" aria-modal="true" aria-labelledby="upm-b-headline">
    <div class="upm-head" data-slot="headB"></div>
    <h2 class="upm-headline" id="upm-b-headline" data-slot="headlineB"></h2>
    <div class="upm-slots" id="upm-slots">
      <div class="upm-slot upm-slot--filled" data-slot-idx="0">
        <div class="upm-slot-box"><img id="upm-slot-0-img" alt="" /></div>
        <span class="upm-slot-label" id="upm-slot-0-label"></span>
      </div>
      <span class="upm-slot-connector"></span>
      <div class="upm-slot upm-slot--empty" data-slot-idx="1">
        <div class="upm-slot-box"></div>
        <span class="upm-slot-label">escolha<br>o sabor</span>
        <button type="button" class="upm-slot-clear" aria-label="Remover sabor">×</button>
      </div>
      <span class="upm-slot-connector upm-slot-connector--dim"></span>
      <div class="upm-slot upm-slot--empty" data-slot-idx="2">
        <span class="upm-slot-pill" data-slot="freeBadge"></span>
        <div class="upm-slot-box"></div>
        <span class="upm-slot-label">Escolha<br>o sabor</span>
        <button type="button" class="upm-slot-clear" aria-label="Remover sabor">×</button>
      </div>
    </div>
    <div class="upm-flavors" id="upm-flavors"></div>
    <div class="upm-actions">
      <button type="button" class="upm-cta upm-cta--finalize" id="upm-b-finalize" disabled data-slot="ctaFinalize"></button>
      <button type="button" class="upm-cta upm-cta--decline" id="upm-b-decline" data-slot="ctaDecline"></button>
    </div>
  </div>
</div>`;

  // ---- utils ----
  function deepMerge(target, source) {
    if (!source) return target;
    const out = Array.isArray(target) ? target.slice() : { ...target };
    for (const key in source) {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        out[key] = deepMerge(target[key] || {}, source[key]);
      } else if (source[key] !== undefined) {
        out[key] = source[key];
      }
    }
    return out;
  }

  function resolveSlotValue(config, slotPath) {
    // 'single.saved' → config.prices.single.saved | config.copy.single.saved
    const parts = slotPath.split('.');
    const tryPath = (root) => parts.reduce((acc, p) => (acc == null ? acc : acc[p]), root);
    return tryPath(config.copy) ?? tryPath(config.prices) ?? tryPath(config.assets) ?? '';
  }

  function fillTemplate(root, config) {
    // image src
    root.querySelectorAll('img[data-slot]').forEach((img) => {
      const v = resolveSlotValue(config, img.dataset.slot);
      if (v) img.src = v;
    });
    // text/HTML slots
    root.querySelectorAll('[data-slot]:not(img)').forEach((el) => {
      const key = el.dataset.slot;
      let v = resolveSlotValue(config, key);
      if (typeof v === 'string') {
        // interpolate {total} etc.
        v = v.replace(/\{(\w+)\}/g, (_, k) =>
          resolveSlotValue(config, 'combo.' + k) || resolveSlotValue(config, k) || ''
        );
        // ctaAccept is inside a button with an SVG sibling — render into a <span>
        const inner = el.querySelector('[data-slot-text]');
        if (inner) inner.innerHTML = v;
        else el.innerHTML = v;
      }
    });
  }

  function labelTwoLines(name) {
    if (name === 'Abacaxi c/ hortelã') return 'Abacaxi<br>c/ hortelã';
    return name;
  }

  // ============================================================
  //   Instance factory
  // ============================================================
  function init(userConfig) {
    const config = deepMerge(DEFAULTS, userConfig || {});

    // ---- resolve mount ----
    const mount =
      typeof config.mount === 'string'
        ? document.querySelector(config.mount)
        : config.mount;
    if (!mount) throw new Error('[BlessyUpsell] mount element not found');

    // ---- render markup (sync via INLINE_TEMPLATE; templateUrl é opcional/futuro) ----
    mount.innerHTML = INLINE_TEMPLATE;
    fillTemplate(mount, config);

    // ---- el refs ----
    const overlay     = mount.querySelector('#upm-overlay');
    const modalA      = mount.querySelector('#upm-a');
    const modalB      = mount.querySelector('#upm-b');
    const slot0Img    = mount.querySelector('#upm-slot-0-img');
    const slot0Label  = mount.querySelector('#upm-slot-0-label');
    const slotsEl    = mount.querySelector('#upm-slots');
    const flavorsEl  = mount.querySelector('#upm-flavors');
    const finalizeBtn = mount.querySelector('#upm-b-finalize');
    const acceptBtn  = mount.querySelector('#upm-a-accept');
    const declineABtn = mount.querySelector('#upm-a-decline');
    const declineBBtn = mount.querySelector('#upm-b-decline');

    // ---- state ----
    let pickedId = null;
    let extras = [];

    // ---- render helpers ----
    function renderFlavors() {
      flavorsEl.innerHTML = config.flavors.map((f) => {
        const tag = f.tag
          ? `<span class="upm-flavor-tag is-${f.tag.type}">${f.tag.label}</span>`
          : '';
        const btn = f.soldOut
          ? `<button class="upm-flavor-add upm-flavor-add--soldout" disabled>esgotado</button>`
          : `<button class="upm-flavor-add" data-add="${f.id}">Adicionar +</button>`;
        return `
          <article class="upm-flavor" data-flavor="${f.id}">
            ${tag}
            <span class="upm-flavor-thumb"><img src="${f.image}" alt="${f.name}" /></span>
            <div class="upm-flavor-body">
              <span class="upm-flavor-eyebrow">Blessy Greens</span>
              <h3 class="upm-flavor-name">${f.name}</h3>
            </div>
            ${btn}
          </article>
        `;
      }).join('');
    }

    function renderSlots() {
      const picked = config.flavors.find((f) => f.id === pickedId) || config.flavors[0];
      slot0Img.src = picked.image;
      slot0Img.alt = picked.name;
      slot0Label.innerHTML = labelTwoLines(picked.name);

      [1, 2].forEach((idx) => {
        const slotEl = slotsEl.querySelector(`[data-slot-idx="${idx}"]`);
        const box = slotEl.querySelector('.upm-slot-box');
        const label = slotEl.querySelector('.upm-slot-label');
        const id = extras[idx - 1];
        if (id) {
          const f = config.flavors.find((x) => x.id === id);
          slotEl.classList.remove('upm-slot--empty');
          slotEl.classList.add('upm-slot--filled');
          box.innerHTML = `<img src="${f.image}" alt="${f.name}" />`;
          label.innerHTML = labelTwoLines(f.name);
        } else {
          slotEl.classList.add('upm-slot--empty');
          slotEl.classList.remove('upm-slot--filled');
          box.innerHTML = '';
          label.innerHTML = idx === 1 ? 'escolha<br>o sabor' : 'Escolha<br>o sabor';
        }
      });

      const isFull = extras.length >= 2;
      flavorsEl.querySelectorAll('.upm-flavor').forEach((card) => {
        card.classList.toggle('is-locked', isFull && !card.querySelector('.upm-flavor-add--soldout'));
      });
      finalizeBtn.disabled = !isFull;
    }

    // ---- open / close ----
    function showModal(which) {
      overlay.classList.add('is-open');
      overlay.classList.toggle('is-fullscreen', which === 'b');
      overlay.setAttribute('aria-hidden', 'false');
      modalA.classList.toggle('is-active', which === 'a');
      modalB.classList.toggle('is-active', which === 'b');
      document.body.style.overflow = 'hidden';
    }
    function hide() {
      overlay.classList.remove('is-open');
      overlay.classList.remove('is-fullscreen');
      overlay.setAttribute('aria-hidden', 'true');
      modalA.classList.remove('is-active');
      modalB.classList.remove('is-active');
      document.body.style.overflow = '';
      config.onClose();
    }

    // ---- public API ----
    function open(opts) {
      pickedId = (opts && opts.pickedFlavorId) || (config.flavors[0] && config.flavors[0].id);
      extras = [];
      renderSlots();
      showModal('a');
    }

    function close() {
      hide();
    }

    function destroy() {
      // unbind listeners by clearing the mount
      mount.innerHTML = '';
      document.body.style.overflow = '';
    }

    // ---- event wiring ----
    declineABtn.addEventListener('click', () => {
      hide();
      config.onDecline([{ id: pickedId, n: 1 }]);
    });
    acceptBtn.addEventListener('click', () => {
      showModal('b');
      renderFlavors();
      renderSlots();
    });
    flavorsEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-add]');
      if (!btn) return;
      if (extras.length >= 2) return;
      extras.push(btn.dataset.add);
      renderSlots();
    });
    slotsEl.addEventListener('click', (e) => {
      const clr = e.target.closest('.upm-slot-clear');
      if (!clr) return;
      const slot = clr.closest('[data-slot-idx]');
      const idx = parseInt(slot.dataset.slotIdx, 10);
      if (idx === 0) return;
      extras.splice(idx - 1, 1);
      renderSlots();
    });
    declineBBtn.addEventListener('click', () => {
      hide();
      config.onDecline([{ id: pickedId, n: 1 }]);
    });
    finalizeBtn.addEventListener('click', async () => {
      if (finalizeBtn.disabled) return;

      const originalHtml = finalizeBtn.innerHTML;
      finalizeBtn.disabled = true;
      finalizeBtn.classList.add('is-loading');
      finalizeBtn.setAttribute('aria-busy', 'true');
      finalizeBtn.innerHTML = '<span class="upm-cta-spinner" aria-hidden="true"></span>';

      const counts = {};
      counts[pickedId] = (counts[pickedId] || 0) + 1;
      extras.forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
      const items = Object.keys(counts).map((id) => ({ id, n: counts[id] }));

      try {
        await config.onAccept(items);
      } catch (err) {
        finalizeBtn.disabled = false;
        finalizeBtn.classList.remove('is-loading');
        finalizeBtn.removeAttribute('aria-busy');
        finalizeBtn.innerHTML = originalHtml;
      }
    });
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) hide();
    });
    function onKey(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) hide();
    }
    document.addEventListener('keydown', onKey);

    // ---- return instance ----
    return { open, close, destroy, _config: config };
  }

  root.BlessyUpsell = { init };
})(window);
